function getPercentageForProgressBar(active, length) {
  const result = `${(Math.max(...active) / length) * 100}%`;
  return result;
}
export default getPercentageForProgressBar;
